import type { AxiosError } from "axios";
import { GenericErrorResponseSchema } from "./index.schema";

type ParsedErrorResponse = {
	code: string;
	message: string;
	detail: string;
};

const parseGenericEOSError = (
	response: unknown,
): ParsedErrorResponse | undefined => {
	const safeResponse = GenericErrorResponseSchema.safeParse(response);
	if (!safeResponse.success) return undefined;
	return {
		message: safeResponse.data.error.message,
		code: safeResponse.data.error.code,
		detail: safeResponse.data.error.detail,
	};
};

export class EOSApiError extends Error {
	code?: string;
	error: AxiosError;
	hasRequest: boolean;
	path?: string;
	response?: ParsedErrorResponse;
	status?: number;

	constructor({ response, ...rest }: AxiosError) {
		super();
		this.error = rest;
		this.hasRequest = !!rest.request;
		this.message = rest.message;
		this.name = "EOSApiError";
		this.path = rest?.config?.url;

		if (response) {
			this.status = response?.status;
			const safeResponse = parseGenericEOSError(response.data);
			if (!safeResponse) return;
			this.message = safeResponse.detail;
			this.code = safeResponse.code;
			this.response = safeResponse;
		}
	}
}
